export default __webpack_public_path__ + "static/media/Daiane Carina Barbieri Ratã.dab75403.png";